import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D7402851-FBF5-4861-8B6E-D141EBBDBB70
 * name hospital
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital.svg
 * tags
 * - Medical / Hospital 
 */
export const HospitalIcon = createSvgIcon(<><path d="M18 14H14V18H10V14H6V10H10V6H14V10H18" /></>, 'HospitalIcon');
export default HospitalIcon